import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
 } from '@angular/common/http';
 import { Observable, throwError } from 'rxjs';
 import { retry, catchError } from 'rxjs/operators';
import { MainService } from './delavci/main.service';
import { Router } from '@angular/router';
import { AppConfigServiceService } from './app-config-service.service';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor{

  constructor(private mainService: MainService, private router: Router, private appConfig: AppConfigServiceService) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
    .pipe(
      retry(1),
      catchError((error: HttpErrorResponse) => {
        /*if(error.status === 500) {
          this.mainService.logout();
          console.log('navigating ' + this.appConfig.configWhichLogin);
          this.router.navigate([this.appConfig.configWhichLogin]);
        }*/
        return throwError(error);
      })
    )

}
}
